<template>
  <section>
    <div class="hero-section">
      <video v-if="fields" :src="`${this.$store.state.base_directory}${fields['Banner Video'].replace(/^public\//, '')}`" class="hero-image" autoplay 
  muted 
  loop
  playsinline></video>
      <div class="hero-content">
        <h1 class="hero-text" v-if="fields">{{ fields['Banner title'] }}</h1>
        <img v-if="fields" :src="`${this.$store.state.base_directory}${fields['Banner logo'].replace(/^public\//, '')}`" alt="Изображение">

      </div>
    </div>
    <div class="banner__desc__container">
        <div class="list" data-animate-group>
            <div class="item" data-animate="slideUp" v-if="fields" v-for="item in fields['Statistics on banner']">
                <div class="title">{{ item.value }}</div>
                <div class="text">{{ item.text }}</div>
            </div>
        </div>
        <div class="arrow__link" data-animate="slideRightToLeft" @click="this.$scrollTo('footer');">
          <svg class="arrow arrow--white" width="92" height="92" viewBox="0 0 92 92" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="0" rx="46" width="92" height="92"/>
            <path d="M57.48 44.85L50.05 37.62L51.72 36L61.16 45.18L62 46L61.16 46.81L51.72 56L50.05 54.37L57.48 47.14L32 47.14L32 44.85L57.48 44.85Z" fill="#FFFFFF"/>
          </svg>
          <svg class="arrow arrow--black" width="92" height="92" viewBox="0 0 92 92" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="0" rx="46" width="92" height="92"/>
            <path d="M57.48 44.85L50.05 37.62L51.72 36L61.16 45.18L62 46L61.16 46.81L51.72 56L50.05 54.37L57.48 47.14L32 47.14L32 44.85L57.48 44.85Z" fill="#050505"/>
          </svg>
        </div>
    </div>
  </section>
  </template>
  
  <script>
  export default {
        props: {
          fields: [Array,Object],
        },
    }
  </script>
  
  <style scoped>
.arrow__link {
  display: inline-block;
  position: absolute;
  top: 0;
  right: 84px;
  width: 92px;
  height: 92px;
  border-radius: 50%;
  background-color: #FFB710;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.4s ease;
}

.arrow__link .arrow {
  position: absolute;
  transition: all 0.5s ease;
}

.arrow__link .arrow--white {
  opacity: 1;
  transform: translateX(-100%); /* Белая стрелка по центру */
}

.arrow__link .arrow--black {
  opacity: 1;
  transform: translateX(0); /* Черная стрелка по центру */
}
.arrow__link:hover{
  background-color: black;
}
.arrow__link:hover .arrow--white {
  opacity: 1;
  transform: translateX(0%); /* Белая стрелка уходит вправо */
}

.arrow__link:hover .arrow--black {
  opacity: 1;
  transform: translateX(100%); /* Черная стрелка заходит в центр */
}



.banner__desc__container{
    margin-top: 48px;
    position: relative;
}
.list{
    display: flex;
    gap: 116px;
    max-width: 68.02%;
    margin-left: 84px;
}
.list .item{
    width: calc((100% / 3) - 77.33);
}
.item .title{
    color: rgb(5, 5, 5);
    font-size: 32px;
    font-weight: 500;
    line-height: 140%;
    letter-spacing: 0%;
    text-align: left;
}
.item .text{
    color: rgb(85, 98, 114);
    font-size: 16px;
    font-weight: 400;
    line-height: 140%;
    letter-spacing: 0%;
    text-align: left;
    padding-bottom: 8px;
}
  .hero-section {
    position: relative;
    width: 100%;
    max-height: 448px;
    overflow: hidden;
  }
  
  .hero-image {
    width: 100%;
    height: auto;
    max-height: 448px;
    object-fit: cover;
  }
  .hero-section::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  pointer-events: none;
}
  .hero-content {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    color: white;
    z-index: 1;
  }
  
  .hero-logo {
    max-width: 150px;
    margin-bottom: 20px;
  }
  
  .hero-text {
/* Header/H3: 24px Medium */
    color: rgb(255, 255, 255);
    font-family: Satoshi;
    font-size: 24px;
    font-weight: 500;
    line-height: 140%;
    letter-spacing: 0%;
    text-align: center;
    max-width: 692px;
    padding-bottom: 21px;
  }
  @media (max-width: 1120px) {
    .list{
      margin-left: unset;
      gap: 40px;
      max-width: 80%;
    }
  }
  @media (max-width: 1024px) {
    .hero-section {
      max-height: 500px;
    }
    .hero-image {
      max-height: 500px;
      height: 500px;
    }
    .hero-text {
      max-width: 600px;
    }

    .arrow__link{
    right: 32px;
    }
    .list{
        display: flex;
        max-width: 85%;
        margin-left: unset;
        gap: 40px;
    }

  }

  @media (max-width: 768px) {
    .list{
    display: flex;
    flex-direction: column;
    gap: 32px;
    max-width: 100%;
    }
    .item .text{
            max-width: 70%;
    } 
    .item .title{
      font-size: 24px;
      padding-bottom: 4px;
    }
    .item .text{
      font-size: 18px;
    }
    .hero-section {
      max-height: 400px;
    }
    .hero-image {
      max-height: 400px;
    }
    .hero-text {
      max-width: 500px;
    }
    .arrow__link{
        width: 64px;
        height: 64px;
    }
    .arrow__link .arrow{
      width: 100%;
      height: 100%;
    }
}
  </style>
  